var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useRef, useEffect, useState } from 'react';
import { getComparator, sortedRows } from './sorterHelpers';
import { DataTableContext } from './DataTableContext';
import { VirtualScroll } from '../';
var DataTableBody = function (_a) {
    var id = _a.id, data = _a.data, order = _a.order, loading = _a.loading, columns = _a.columns, orderBy = _a.orderBy, itemHeight = _a.itemHeight, checkboxConfig = _a.checkboxConfig, dontFormatRow = _a.dontFormatRow, multiLevelStyleSupport = _a.multiLevelStyleSupport, _b = _a.multiLevelSortSupport, multiLevelSortSupport = _b === void 0 ? false : _b;
    var ctx = useContext(DataTableContext);
    var parentContainer = useRef(null);
    var dataGridBody = useRef(null);
    var _c = useState(false), hasShadow = _c[0], _setHasShadow = _c[1];
    var hasShadowRef = useRef(hasShadow);
    var setHasShadow = function (data) {
        hasShadowRef.current = data;
        _setHasShadow(data);
    };
    useEffect(function () {
        if (parentContainer && parentContainer.current) {
            parentContainer.current.addEventListener('scroll', function (e) {
                if (parentContainer && parentContainer.current) {
                    if (parentContainer.current.scrollLeft > 0 && !hasShadowRef.current) {
                        setHasShadow(true);
                    }
                    if (parentContainer.current.scrollLeft === 0 && hasShadowRef.current) {
                        setHasShadow(false);
                    }
                }
            });
        }
    });
    var getHeaderWidth = function (columnId, defaultWidth) {
        if (!columnId) {
            // window.location.reload();
            return defaultWidth;
        }
        var headerCell = document.querySelector("#" + id + " .data-grid-head [data-column=\"" + columnId + "\"]");
        return headerCell ? parseInt(headerCell.style.minWidth) : defaultWidth;
    };
    useEffect(function () {
        var _a;
        if ((data === null || data === void 0 ? void 0 : data.length) === 0) {
            if (dataGridBody.current) {
                var headContainer = (_a = document.querySelector('.data-grid-head-container')) === null || _a === void 0 ? void 0 : _a.scrollWidth;
                dataGridBody.current.style.width = headContainer + 'px';
            }
        }
        else {
            if (dataGridBody.current) {
                dataGridBody.current.style.width = '';
            }
        }
    }, [data, columns]);
    var renderableRows = sortedRows(data, getComparator(order, orderBy), multiLevelSortSupport);
    var SingleRow = function (_a) {
        var index = _a.index, style = _a.style;
        var row = renderableRows[index];
        var rowClassName = index % 2 === 0 ? 'row-even' : 'row-odd';
        var isLastCell = function (index) {
            return columns.filter(function (c) { return typeof c !== 'undefined'; }).length - 1 === index ? true : false;
        };
        var isLastFixedCell = function (cell) {
            var fixedCells = [];
            columns.forEach(function (c) {
                if (c.fixed) {
                    fixedCells.push(c);
                }
            });
            if (fixedCells.length > 0) {
                return fixedCells[fixedCells.length - 1].id === cell.id;
            }
            return false;
        };
        var getMultiLevelStyle = function () {
            if (multiLevelStyleSupport) {
                var level = row.level;
                var baseColor = 241;
                if (level === 0 && !row.opened) {
                    baseColor = 255;
                }
                else {
                    baseColor -= level * 10;
                }
                return "rgb(" + baseColor + ", " + baseColor + ", " + baseColor + ")";
            }
            return '#ffffff';
        };
        return (React.createElement("div", { className: "data-grid-row " + rowClassName, key: "data-table-" + id + "-" + index, style: style }, columns.filter(function (c) { return typeof c !== 'undefined'; }).map(function (cell, i) {
            if (!cell.invisible) {
                var left = 0;
                var headerWidth = getHeaderWidth(cell.id, cell.width);
                if (cell.fixed) {
                    left = columns.slice(0, i).reduce(function (sum, v) { return sum + v.width; }, 0);
                }
                var value = cell.render && dontFormatRow !== index + 1 ? cell.render(row[cell.id], row, index)
                    : row[cell.id];
                var checked = checkboxConfig.enable ? ctx.selectedRowIds.includes(row[checkboxConfig.uniqueId]) : false;
                var className = "data-grid-cell " + (cell.fixed ? 'fixed-column' : '') + " " +
                    ((cell.ellipsis ? 'ellipsis' : '') + " ") +
                    ("" + (checked ? 'checked' : ''));
                return (React.createElement("div", { className: className, "data-column": cell.id, key: "data-table-cell-" + id + "-" + i, style: __assign({
                        left: left + 'px',
                        minWidth: headerWidth,
                        maxWidth: headerWidth,
                        textAlign: cell.align || 'left',
                        boxShadow: isLastFixedCell(cell) && hasShadow ? '3px 0px 5px -2px #dbdcde' : '',
                        clipPath: isLastFixedCell(cell) && hasShadow ? 'inset(0px -15px 0px 0px)' : '',
                        backgroundColor: getMultiLevelStyle(),
                    }, cell.style) }, cell.tooltip ? (
                // <Tooltip title={value as string} placement="top-start">
                React.createElement("span", null, value)
                // </Tooltip>
                ) : isLastCell(i) ?
                    React.createElement("div", { className: 'last-cell-item-container' }, value) : value));
            }
            else {
                return (React.createElement(React.Fragment, null));
            }
        })));
    };
    return (React.createElement("div", { className: "data-grid-container", ref: parentContainer },
        React.createElement("div", { className: "data-grid", "aria-label": "Data Grid" },
            React.createElement("div", { className: "data-grid-body", id: id + "_grid", ref: dataGridBody },
                React.createElement(VirtualScroll, { itemHeight: itemHeight || 50, render: SingleRow, rows: renderableRows, parent: ".data-grid-container" })))));
};
export default DataTableBody;
